import React, { Component } from "react";
//import Axis from "./Axis";
import Barchart from "./Barchart";
import Barchart2 from "./Barchart2";

import Scatterplot from "./Scatterplot";

class Compare extends Component {
  constructor(props) {
    super(props);
    this.state = {
      test: "test",
      compareValue: "temp"
    };
    this.btnClicked = this.btnClicked.bind(this);
    this.changeCompareValue = this.changeCompareValue.bind(this);
    this.setTempVal = this.setTempVal.bind(this);
    this.setWindVal = this.setWindVal.bind(this);

    //const compareValue = "temp";
  }

  changeCompareValue(value) {
    //this.setState({ compareValue: value });
  }

  setTempVal(e) {
    //this.setState({ compareValue: "temp" });
  }

  setWindVal(e) {
    e.preventDefault();
    //e.preventDefault();
    this.setState({ compareValue: "windSpeed" });
    alert("HI");
  }

  btnClicked(e) {
    console.log(this.props.items[0].forecasts);
    //delete(id);
  }

  render() {
    let svgheight = this.props.items.length * 200;
    let noitems = this.props.items.length;

    return (
      <div className="compare">
        <h2>5 Day Forecast Comparison</h2>
        {/* 
        <p>
          Compare: <button onClick={this.setTempVal()}>Temperature</button>
          <button onClick={this.setWindVal}>Wind</button>
          <button>Humidity</button>
        </p>
        */}
        {this.props.dataLoaded ? (
          //{this.props.items[0].forecasts != undefined ? (

          <div>
            {" "}
            <svg width="850" height={svgheight} id="svg">
              {this.props.items.map(
                (item, index) =>
                  // Check to see if Forecasts has been loaded, if so load barchart

                  // Wait to see if forecasts has been loaded
                  item.forecasts.length > 0 && (
                    <Barchart
                      key={item.id}
                      width={800}
                      height={180}
                      x={0}
                      y={index * 200}
                      data={item}
                      compareValue={this.state.compareValue}
                      //compareValue={compareValue}
                    />
                  )

                // End of map
              )}
            </svg>
          </div>
        ) : (
          <div>DATA NOT LOADED YET</div>
        )}

        <div className="compare-background" />
      </div>
    );
  }
}

export default Compare;
